import { useContext } from "react";
import * as PropTypes from "prop-types";
import { buyNowContext } from "../BuyNow";
import { calcTotalPrice } from "../../utils/pricingHelper";

/**
 * Return a string representing the total price of the order.
 */
const TotalPrice = ({ hideDecimalIfWhole, includeShippingCost }) => {
  const { lineItems, promoCode, salesTaxRates, shippingStageState } = useContext(buyNowContext);
  const { state, country, shippingMethod } = shippingStageState;

  let result = calcTotalPrice(lineItems, country, state, includeShippingCost ? shippingMethod : null, salesTaxRates, promoCode);

  if (hideDecimalIfWhole && result % 1 === 0)
    result = String(result);
  else
    result = result.toFixed(2);

  return result;
};

TotalPrice.propTypes = {
  hideDecimalIfWhole: PropTypes.bool,
  includeShippingCost: PropTypes.bool
};

TotalPrice.defaultProps = {
  hideDecimalIfWhole: false,
  includeShippingCost: true
};

export default TotalPrice;